import {
    PLAN_GET_PLAN_LNG_LIST_BEGIN,
    PLAN_GET_PLAN_LNG_LIST_SUCCESS,
    PLAN_GET_PLAN_LNG_LIST_FAILURE,
    PLAN_GET_PLAN_LNG_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getPlan_lngList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: PLAN_GET_PLAN_LNG_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'get',
            url:'/api/gc/batch/lng',
            data:params,
          }).then( data => {
              dispatch({
                  type: PLAN_GET_PLAN_LNG_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: PLAN_GET_PLAN_LNG_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetPlan_lngListError() {
    return {
      type: PLAN_GET_PLAN_LNG_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PLAN_GET_PLAN_LNG_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getPlan_lngListPending: true,
          getPlan_lngListError: null,
        };
  
      case PLAN_GET_PLAN_LNG_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        console.log(action.data)
        action.data.data.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          plan_lngById:byId,
          plan_lngList:items,
          plan_lngPage: action.data.page,
          plan_lngSize: action.data.size,
          plan_lngTotal: action.data.totalCount,
          getPlan_lngListPending: false,
          getPlan_lngListError: null,
        };
  
      case PLAN_GET_PLAN_LNG_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getPlan_lngListPending: false,
          getPlan_lngListError: action.data.error,
        };
  
      case PLAN_GET_PLAN_LNG_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getPlan_lngListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/plan/redux/getPlan_lngList.js